import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e1ab1848&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModularLanderTemplate: require('/usr/src/app/components/modular-lander/modular-lander-template.vue').default,PageTestTemplate: require('/usr/src/app/components/product-new/page-test-template.vue').default,PageTemplate: require('/usr/src/app/components/product-new/page-template.vue').default,ProductPageCardPreview: require('/usr/src/app/components/product-page/product-page-card-preview/product-page-card-preview.vue').default})
